import React from "react"
import SbEditable from "storyblok-react"
import { blokType } from "../../types"

import { CardCmp, CardProps } from "./Card"
import { AttributeCmp } from "./Attribute"

interface CardWrapperBlokProps {
  blok: CardProps & blokType
}

export const S22Card: React.FC<CardWrapperBlokProps> = ({ blok, onClick }) => (
  <SbEditable content={blok}>
    <CardCmp
      card_image={blok.card_image}
      card_logo={blok.card_logo}
      label={blok.label}
      title={blok.title}
      description={blok.description}
      list={blok.list}
      form={blok.form}
      card_link={blok.card_link}
      buttons={blok.buttons}
      link_modal={blok.link_modal}
      background_image={blok.background_image}
      background_image_asset={blok.background_image_asset}
      button_position={blok.button_position}
      background_color={blok.background_color}
      border_accent={blok.border_accent}
      onClick={onClick}
      program_category={blok.program_category}
      header_image={blok.header_image}
      heading={blok.heading}
      attribute={blok.attribute}
      attribute_color={blok.attribute_color}
      hover={blok.hover}
      shadow={blok.shadow}
    />
  </SbEditable>
)

export const S22Attribute: React.FC<AttributeWrapperBlokProps> = ({ blok }) => (
  <SbEditable content={blok}>
    <AttributeCmp
      icon={blok.icon}
      title={blok.title}
    />
  </SbEditable>
)
